@if ((useLazyLoad && !isLoaded) || quotes?.length > 0) {
  <wc-wrapper [contentWrapper]="wrapper" [componentWidth]="showMoreDesktop ? '' : 'is-full-width'">
    <sd-visual-quote sd-component-wrapper-component
      [sdSpyTarget]="componentUid"
      [data]="quotes"
      [context]="context"
      [twicPicsAutoSize]="!isFirst"
      [brand]="brandCorner"
      [activeBrand]="activeBrand"
      [isLoading]="useLazyLoad && !isLoaded"
    />
  </wc-wrapper>
}
